import type { PointAvailability, PointStatus } from '@ev/shared'
import { useStrings } from '../i18n'
import { formatDateTime } from './format'
import { useLocale } from './useLocale'

/**
 * Live availability for one charge point.
 *
 * A point with no dynamic row is `unknown`, never `free` - the registry's
 * silence is not an answer, and a driver who drives to an "available" charger
 * that was never reporting has been misled by the map, not by the operator.
 */

const CLASS_BY_STATE: Readonly<Record<PointAvailability, string>> = {
  free: 'ev-status--free',
  occupied: 'ev-status--occupied',
  unavailable: 'ev-status--unavailable',
  unknown: 'ev-status--unknown',
}

export const StatusBadge = ({ status }: { status: PointStatus | undefined }) => {
  const strings = useStrings()
  const locale = useLocale()
  const state: PointAvailability = status?.state ?? 'unknown'
  const timestamp = status?.ts

  return (
    <span
      className={`ev-status ${CLASS_BY_STATE[state]}`}
      title={
        timestamp === undefined
          ? undefined
          : strings.detail.statusAt(formatDateTime(timestamp, locale))
      }
    >
      <span className="ev-status__dot" aria-hidden="true" />
      {strings.availability[state]}
    </span>
  )
}
